import React from 'react'
import { Drawer, DrawerHeader, DrawerContent } from '@sainsburys-tech/bolt'
import * as Styled from './SdfDrawer.styles'

const SdfDrawer = ({ isDrawerOpen, toggleSdfDrawer }) => {
  const toggleCallback = () => {
    if (isDrawerOpen) {
      toggleSdfDrawer()
    }
  }

  return (
    <Drawer
      position='right'
      show={isDrawerOpen}
      onClose={toggleCallback}
      padding={false}
      id='sdf-drawer'
      ariaLabelledBy='sdf-drawer-link'
    >
      <DrawerHeader> How supplier deliveries work </DrawerHeader>
      <Styled.DrawerContentWrapper>
        <DrawerContent>
          <Styled.Section data-test='meaning-section'>
            <h4>What does delivered by our supplier mean?</h4>
            <p>It means that our supplier will handle delivery. You don’t need to do anything differently.</p>
            <ul>
              <li>Argos will take payment</li>
              <li>Our supplier will deliver your order by post or courier</li>
              <li>You can view your order by using your Argos account and through guest checkout</li>
            </ul>
          </Styled.Section>
          <Styled.Section data-test='delivery-section'>
            <h4>Arranging delivery</h4>
            <p>
              If your order is a large item, our supplier will contact you to arrange a delivery date. Large items
              include:
            </p>
            <ul>
              <li>Sofas, fridges, freezers</li>
            </ul>
          </Styled.Section>
          <Styled.Section data-test='questions-section'>
            <h4>Got questions?</h4>
            <p>
              You can find more information about what this means for delivery, cancellations and returns on our{' '}
              <a href='/help/'>help pages</a>.
            </p>
          </Styled.Section>
        </DrawerContent>
      </Styled.DrawerContentWrapper>
    </Drawer>
  )
}

export default SdfDrawer
